import { Ref, ref } from 'vue';
import { useValidation, useTask } from '@/ui/concerns';
import { IssueTemplateEditable } from '@/ui/DTO';
import { validate } from '@/entities/issueTemplate';
import { SelectOptions } from '@/ui/types';
import { filterListToOptionsUsers, sequence } from '@/ui/helpers';
import { filter as userFilter, filter as getAllUsers } from '@/services/api/resources/user';
import { filter as getAllGroups } from '@/services/api/resources/group';
import { Permissions } from '@/ui/auth/auth.types';
import { kebabCase } from 'lodash';
import { useAssignees } from '@/ui/concerns/useAssignees';

export function useIssueTemplate(record: Ref<IssueTemplateEditable>) {
  const {
    validationErrors,
    hasNoValidationErrors,
    showValidationErrors,
  } = useValidation<IssueTemplateEditable>(validate, record);

  const userActionApprovalOptions = ref<SelectOptions<string>>([]);

  const {
    assigneeOptions,
    groupsOptions,
    fillAssigneeOptions,
    fillGroupsOptions,
    getUsers,
  } = useAssignees();

  const getFilters = useTask(
    () => sequence(getAllUsers(), getAllGroups()),
    ([users, groups]) => {
      fillGroupsOptions(groups);
      fillAssigneeOptions(users);
      getActionApprovalUsers.run();
    },
  );

  const getActionApprovalUsers = useTask(
    () =>
      userFilter({
        permission: [Permissions.APPROVE_ALL_ACTIONS, Permissions.APPROVE_ASSIGNED_ACTIONS].map(kebabCase),
      }),
    response => {
      userActionApprovalOptions.value = filterListToOptionsUsers(response.data);
    },
  );

  return {
    validationErrors,
    hasNoValidationErrors,
    showValidationErrors,

    assigneeOptions,
    groupsOptions,
    userActionApprovalOptions,

    getUsers,
    getFilters,
    getActionApprovalUsers,

    fillAssigneeOptions,
  };
}
